'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var configure = require('../lib/configure.js');

var put = require('../dag/put.js');

var createPut = function createPut(codecs, options) {
  var fn = configure.configure(function (api) {
    var dagPut = put.createPut(codecs, options);

    function put$1(_x) {
      return _put$.apply(this, arguments);
    }

    function _put$() {
      _put$ = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(obj) {
        var options,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                return _context.abrupt("return", dagPut(obj, _objectSpread({}, options, {
                  storeCodec: 'dag-pb',
                  hashAlg: 'sha2-256',
                  version: 1
                })));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _put$.apply(this, arguments);
    }

    return put$1;
  });
  return fn(options);
};

exports.createPut = createPut;